import { Entry } from 'contentful';
import { getContentPage } from 'utils/useContentful';
import { ContentPageType } from 'types/Content';
import { logSafelyToConsole } from 'utils';

export enum ContentPageActionType {
  GET_CONTENT_PAGE_REQUEST = 'GET_CONTENT_PAGE_REQUEST',
  GET_CONTENT_PAGE_SUCCESS = 'GET_CONTENT_PAGE_SUCCESS',
  GET_CONTENT_PAGE_ERROR = 'GET_CONTENT_PAGE_ERROR'
}

export const requestGetContentPage = async (
  slug: string,
  dispatch: React.Dispatch<{
    type: ContentPageActionType;
    payload: { entry: Entry<ContentPageType> } | null;
  }>,
  content_type?: string,
  include?: number,
): Promise<void> => {
  const {
    GET_CONTENT_PAGE_REQUEST,
    GET_CONTENT_PAGE_SUCCESS,
    GET_CONTENT_PAGE_ERROR
  } = ContentPageActionType;

  dispatch({
    type: GET_CONTENT_PAGE_REQUEST,
    payload: null
  });

  try {
    const entry = await getContentPage(slug, content_type, include);

    logSafelyToConsole({ entry });
    if (entry) {
      dispatch({
        type: GET_CONTENT_PAGE_SUCCESS,
        payload: { entry }
      });
    } else {
      dispatch({
        type: GET_CONTENT_PAGE_ERROR,
        payload: null
      });
    }
  } catch (err) {
    dispatch({
      type: GET_CONTENT_PAGE_ERROR,
      payload: null
    });
  }
};
